(function () {


    /**
     * Fix for iOS devices
     * Uses the background-positon-y property of the given parallax element to create a parallax effect
     * Therefore on each scroll the position (in percentage) of the y-position of the background image  is recalculated
     *
     * @param parallaxElement
     * @constructor
     */
    function Parallax(parallaxElement) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this;

        /**
         * Element with the background image to be used for parallax effect
         */
        this.parallaxElement = parallaxElement;

        /**
         * Height of the parallax element
         * @type {number}
         */
        this.elementHeight = 0;

        /**
         * Current height of the viewport - is updated on resize
         * @type {number}
         */
        this.viewportHeight = 0;

        /**
         * Current position of the element - is updated on resize
         * @type {number}
         */
        this.elementPosition = 0;

        /**
         * Size of the range in which the parallax element is visible
         * @type {number}
         */
        this.visibleRange = 0;

        /**
         * Position of the start of the visibility range of the parallax element in px
         * @type {number}
         */
        this.visibilityStart = 0;

        /**
         * Position of the end of the visibility range of the parallax element in px
         * @type {number}
         */
        this.visibilityEnd = 0;



        /**
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {

            // Remove default parallax
            $(_this.parallaxElement).removeClass('activate-background-image-parallax-effect')

            // Set initial values
            _this.setPositions();

            // Set new positions if page is resized
            _this.recalculateOnResize();

            $(document).on('scroll', function() {
                _this.adjustParallaxImagePosition();
            });
        };


        /**
         * Adjusts the background-position-y property to create parallax effect
         */
        this.adjustParallaxImagePosition = function() {
            let currentScroll = $(document).scrollTop();

            isBeforeElementIsVisible = currentScroll < _this.visibilityStart;
            isAfterElementIsVisible = currentScroll > _this.visibilityEnd;

            if (!isBeforeElementIsVisible && !isAfterElementIsVisible) {
                currentPercentage = _this.calculateScrolledPercentage(currentScroll);
                $(_this.parallaxElement).css('background-position-y', currentPercentage + '%');
            } else if (isAfterElementIsVisible) {
                $(_this.parallaxElement).css('background-position-y', 100 + '%');
            } else if (isBeforeElementIsVisible) {
                $(_this.parallaxElement).css('background-position-y', 0 + '%');
            }


        }

        /**
         * Calculates the share of the visibility range that has already been scrolled
         *
         * @param currentScroll
         * @returns {number}
         */
        this.calculateScrolledPercentage = function(currentScroll) {

            // Distance inside the visible range, that has been scrolled, in px
            var visibleRangeScrolledOffset = currentScroll - _this.visibilityStart;

            // The share of the visible range, that has been scrolled
            var visibleRangeScrolledShare = _this.visibleRange / visibleRangeScrolledOffset;

            // Calculate percentage
            var currentPercentage = 100 / visibleRangeScrolledShare;


            if (currentPercentage > 100) {
                return 100;
            } else if (currentPercentage < 0) {
                return 0;
            }
            return currentPercentage
        }

        /**
         * Trigger recalculation if the window size changes
         * A resize could change the position of the element and the viewport height, so recalculation is required
         */
        this.recalculateOnResize = function() {
            $(window).resize(function () {
                _this.setPositions();
                _this.adjustParallaxImagePosition($(document).scrollTop());
            });
        }

        /**
         * Sets the positions required for all calculations
         */
        this.setPositions = function() {
            _this.viewportHeight = $(window).height();
            _this.elementPosition = _this.parallaxElement.offsetTop;
            _this.visibilityStart = _this.elementPosition - _this.viewportHeight;
            _this.visibilityEnd = _this.elementPosition;
            _this.visibleRange = _this.viewportHeight;
        }

        /**
         * initialize call navigation
         */
        _this.init();
    }

    window.Jumpers = window.Jumpers || {};

    window.Jumpers.Parallax = Parallax;
})();

$(document).ready(function () {
    // Initialize only if it is an iOS device
    // iPad Pro has a Mac user agent but requires the bugfix parallax
    // To apply the bugfix-parallax only to iPad Pro the maxTouchPoints are used to check if the device has a touch screen
    var isIOS = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent) && !window.MSStream  && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
    if (isIOS) {
        $('.js-parallax-element').each(function (key, parallaxElement) {
            new window.Jumpers.Parallax(parallaxElement);
        })
    }
});
